<template>
  <button class="tg__button" :class="customClass" type="button" @click="$emit('click', $event)">
    <slot></slot>
  </button>
</template>

<script>
/**
 * Interface
 * <tg-button confirm></tg-button>
 */
export default {
  created() {
    if (this.$attrs["confirm"] === "" || this.$attrs["confirm"] === true || this.$attrs["confirm"] === "true") {
      this.customClass = "confirm";
    }

    if (this.$attrs["dark"] === "" || this.$attrs["dark"] === true || this.$attrs["dark"] === "true") {
      this.customClass = "dark";
    }
  },
  data() {
    return {
      customClass: undefined,
    };
  },
};
</script>

<style scoped>
.tg__button {
  margin-left: 1px;
  margin-right: 1px;
  min-width: 120px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: rgb(212, 212, 212);
  border-width: 0;
  border-radius: 3px;
  color: black;
}

.tg__button:active {
  background-color: rgb(230, 230, 230);
}

/* <tg-button disabled></tg-button>  */
button[disabled="disabled"] {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Color Declartion */
button[color="confirm"] {
  color: #fff;
  background: linear-gradient(to bottom, #6cb3fa, #067dff);
  border-width: 0;
  border-radius: 3px;
}
button[color="confirm"]:active {
  background: #067dff;
}

button[color="yellow"] {
  color: black;
  background: linear-gradient(to bottom, #cffa6c, #a0ff06);
  border-width: 0;
  border-radius: 3px;
}
button[color="yellow"]:active {
  color: red;
}

button[color="dark"] {
  color: #fff;
  background: linear-gradient(to bottom, #1a2a3a, #000000);
  border-width: 0;
  border-radius: 3px;
}
button[color="dark"]:active {
  background: black;
}

/* <tg-button class="confirm"></tg-button>  */
.confirm {
  color: #fff;
  background: linear-gradient(to bottom, #6cb3fa, #067dff);
  border-width: 0;
  border-radius: 3px;
}
.confirm:active {
  background: #067dff;
}

.dark {
  color: grey;
  background: linear-gradient(to bottom, #1a2a3a, #000000);
  border-width: 0;
  border-radius: 3px;
}

.dark:active {
  background: #067dff;
}
</style>
